'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = undefined;

var _sign = require('./sign');

var request = exports.request = async function request(method, params, apiKey, apiSecret) {
  var message = constructMessage(method, params);
  var headers = getHeaders(apiKey, apiSecret, message);
  var uri = 'https://api.changelly.com';
  var res = await fetch(uri, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(message)
  });

  if (res.status !== 200) {
    var text = await res.text();
    throw text;
  } else {
    var jsonRes = await res.json();
    if (jsonRes.error) throw jsonRes.error;

    return jsonRes.result;
  }
};

var constructMessage = function constructMessage(method, params) {
  var id = Date.now().toString(); // use date.now as unique id for each request
  var message = {
    jsonrpc: "2.0",
    id: id,
    method: method,
    params: params
  };
  return message;
};

var getHeaders = function getHeaders(apiKey, apiSecret, message) {
  var sign = (0, _sign.signMessage)(message, apiSecret);
  var headers = {
    'Content-Type': 'application/json',
    'api-key': apiKey,
    'sign': sign
  };
  return headers;
};